var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchLoopIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.425 26.703l-8.116-8.116a9.29 9.29 0 001.941-5.712 9.319 9.319 0 00-2.747-6.628A9.306 9.306 0 0012.875 3.5c-2.503 0-4.86.978-6.628 2.747A9.3 9.3 0 003.5 12.875c0 2.503.978 4.86 2.747 6.628a9.3 9.3 0 006.628 2.747 9.298 9.298 0 005.71-1.938l8.115 8.113a.257.257 0 00.363 0l1.362-1.36a.256.256 0 000-.362zm-10.6-8.878a6.962 6.962 0 01-4.95 2.05 6.962 6.962 0 01-4.95-2.05 6.962 6.962 0 01-2.05-4.95c0-1.869.728-3.628 2.05-4.95a6.962 6.962 0 014.95-2.05c1.869 0 3.628.725 4.95 2.05a6.962 6.962 0 012.05 4.95 6.957 6.957 0 01-2.05 4.95z",
    fill: "#ADC6FF"
  })));
}

export default __webpack_public_path__ + "./fonts/search-loop-icon.9c95d7453107f246ae6deaa3f9fe4ba6.svg";
export { SvgSearchLoopIcon as ReactComponent };